var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z",
    fill: "#FDE047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15.8C11.6307 15.8 12.75 14.6808 12.75 13.3C12.75 11.9193 11.6307 10.8 10.25 10.8C8.86929 10.8 7.75 11.9193 7.75 13.3C7.75 14.6808 8.86929 15.8 10.25 15.8Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 15.8C23.1307 15.8 24.25 14.6808 24.25 13.3C24.25 11.9193 23.1307 10.8 21.75 10.8C20.3693 10.8 19.25 11.9193 19.25 13.3C19.25 14.6808 20.3693 15.8 21.75 15.8Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 23.8C14.4001 21.4 17.6001 21.4 20.5001 23.8C20.8501 24.1 21.1501 23.6 20.9001 23.15C20.0001 21.45 18.2501 19.9 16.0001 19.9C13.7501 19.9 11.9501 21.45 11.1001 23.15C10.8501 23.6 11.1501 24.1 11.5001 23.8Z",
    fill: "#664E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji2);
export default __webpack_public_path__ + "static/media/emoji_2.cea508841f0466272a498eebf49d1544.svg";
export { ForwardRef as ReactComponent };